<template>
  <router-view/>
</template>

<script>
  export default {
    name: 'ManagerConsults',
  }
</script>

<style scoped>
</style>
